// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqH, FaqP } from "../../components/support/faqPages";

// ** Img Imports
import aupImg from "../../../public/images/aup.jpg";

const AutoPay = () => (
  <Layout>
    <SEOHead title="Autopay" />
    <FaqTemplate title="Autopay">
      <FaqH>How do I set up Autopay?</FaqH>

      <FaqP>
        Setting up Autopay is easy! If you&#8217;re placing an order for new
        service, just make sure you leave the checkbox selected for &#8216;Save
        Card for Autopay&#8217; when submitting your order.
      </FaqP>
      <FaqP>
        If you already have service and want to set up autopay, there is an
        option to save your card for autopay when you click the &#8216;Pay
        Online&#8217; link in your invoice emails. That will save the card you
        are using that day for autopay moving forward.
      </FaqP>

      <FaqH>How does Autopay work?</FaqH>
      <FaqP>
        Each month when your new invoice is generated by our system, your
        payment will be automatically taken from a card on file on the day the
        invoice is created. Depending on your billing cycle, this may be prior
        to your actual due date.
      </FaqP>

      <FaqH>How do I stop Autopay?</FaqH>
      <FaqP>
        Use the form below to contact us to stop Autopay on your account. Keep
        in mind, if you stop Autopay you will need to make your payment on each
        monthly invoice prior to the due date to avoid service interruption.
      </FaqP>

      <Image
        className="img-fluid"
        placeholder="blur"
        src={aupImg}
        alt="Autopay"
      />
    </FaqTemplate>
  </Layout>
);

export default AutoPay;
